'use strict';
import axios from "axios";
import Configuration from "@/Common/Configuration";
import Utility from "@/Common/Utility";


function NavigationService(vueComponent){

    this.vueComponent = vueComponent;

    //this.Paths= [];

    this.GetPaths = function () {
        let paths = [];

        if (Utility.GetSession("NavigationPath") == null) {
            Utility.SaveSession("NavigationPath", []); 
        }

        paths = Utility.GetSession("NavigationPath");

        return paths;
    },


    this.SavePaths = function (paths) {
        paths = Utility.SaveSession("NavigationPath", paths);
    },


    this.GoTo = function (path, argumentObject) {
        let absolutePath = path;
        let paths;
        let currPath;
        let VirtualDirectory;


        paths = this.GetPaths();

        currPath = window.location.pathname + window.location.search;

 
        if (typeof (AppSettings) != "undefined" && typeof (AppSettings) == "object") {

            if (AppSettings.VirtualDirectory != null && AppSettings.VirtualDirectory != "") {
                VirtualDirectory = "/" + AppSettings.VirtualDirectory;
             }
            else {
                VirtualDirectory = "";
            }
        }



        if (path[0] == '/' && path.indexOf(VirtualDirectory) != 0) {
            path = VirtualDirectory + path;
        }


        if (path[0] != '/') {
            absolutePath = this.ConvertToAbsolutePath(path);
        }
        else {
            absolutePath = path;
        }

 

        if (!this.MatchLastPath()) {


            paths.push(
                {
                    Path: absolutePath
                }
            );
        }

        paths.push(
            {
                Path: absolutePath,
                Argument: argumentObject,
                CreateTime : new Date()
            }
        );

        this.SavePaths(paths);

        this.vueComponent.$router.push(path);
    };



    this.Goto = this.GoTo;

    this.ConvertToAbsolutePath = function (path) {
        let absolutePath;
        var linkElement = document.createElement("a");


        linkElement.href = path + "";

        absolutePath = (linkElement.pathname + linkElement.search + linkElement.hash);

        return absolutePath;
    };

    this.GoBack = function () {
        let pathInfo;
        let paths;

        paths = this.GetPaths();
        
        if (paths.length > 0) {
            this.PopPath();

            pathInfo = this.PeekPath();

            this.vueComponent.$router.push(pathInfo.Path);
        }
        else {
            this.vueComponent.$router.go(-1);
        }
       
    };


    this.MatchLastPath = function () {
        let paths;
        let match = false;
        let pathInfo;
        let currPath;


        paths = this.GetPaths();

        currPath = window.location.pathname + window.location.search;

        if (paths.length > 0) {
            pathInfo = this.PeekPath();

            if (pathInfo.Path == currPath) {
                match = true;
            }
        }

        return match;
    },//end this.MatchLastPath = function () {


    this.PushPath = function (pathInfo) {
        let paths;

        paths = this.GetPaths();

        paths.push(pathInfo);

        this.SavePaths(paths);
    },


    this.PeekPath = function () {
        let pathInfo = null;
        let paths;

        paths = this.GetPaths();

        if (paths.length > 0) {
            pathInfo = paths[paths.length - 1];
        }

        return pathInfo;
    },


    this.PopPath = function () {
        let pathInfo = null;
        let paths;

        paths = this.GetPaths();

     
        if (paths.length > 0) {
            pathInfo = paths[paths.length - 1];

            paths.splice(paths.length - 1, 1);
        }

        this.SavePaths(paths);

        return pathInfo;
    }

}


export default NavigationService;

